/** Single source of truth for admin REST + Socket.IO base URL. */
export function getAdminApiBaseUrl() {
  const envBase = process.env.REACT_APP_API_BASE_URL?.trim();
  if (envBase) return envBase;

  // Local dev fallback: when admin runs on localhost, use local backend.
  if (typeof window !== "undefined") {
    const host = String(window.location?.hostname || "").toLowerCase();
    if (host === "localhost" || host === "127.0.0.1") {
      return "http://localhost:5001";
    }
  }

  return (
    "https://healapi.healbid.com"
  );
}
